class restaurantMenu extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector("#menu-content__image-modal");
    this.closeModal = this.querySelector('.menu-content__image-close');
    this.modalBackground = this.querySelector('.menu-content__image-modal-background');
    this.modalContent = this.querySelector('.menu-content__image-modal-content');
    this.html = document.querySelector('html');

    // open modal
    this.zoomButtons = this.querySelectorAll(".menu-content__zoom");
    this.zoomButtons.forEach(zoomButton => {
      zoomButton.addEventListener('click', this.openZoomModal.bind(this));
    });

    // close modal
    this.closeModal.addEventListener("click", this.closeZoomModal.bind(this));
    this.modalBackground.addEventListener("click", this.closeZoomModal.bind(this));

    // enlarge/shrink modal content
    this.modalContent.addEventListener("click", this.enlargeZoomModal.bind(this));
  }

  async openZoomModal(e) {
    // get images from current menu
    let currentMenu = e.currentTarget.dataset.menu;
    let currentMenuPages = this.querySelector("#" + currentMenu);
    let currentMenuImages = currentMenuPages.querySelectorAll(".menu-content__image-container");

    // add the full sized images to the modal content
    currentMenuImages.forEach(image => {
      let imageUrl = image.dataset.fullImage;
      let fullImage = new Image();
      fullImage.src = imageUrl;
      this.modalContent.appendChild(fullImage);
    });

    // prevent page scrolling and open modal
    this.html.classList.add('menu-content-open');
    this.modal.classList.add('menu-content__image-modal--open');
  }

  async enlargeZoomModal() {
    // make the images in modal content larger/smaller on click
    this.modalContent.classList.toggle('menu-content__image-modal-content--zoomed');
  }

  async closeZoomModal() {
    // close modal, re-enable scrolling, empty modal content and reset zoomed class
    this.modal.classList.remove('menu-content__image-modal--open');
    this.html.classList.remove('menu-content-open');
    this.modalContent.innerHTML = "";
    this.modalContent.classList.remove('menu-content__image-modal-content--zoomed');
  }
}
if (!customElements.get("restaurant-menu")) customElements.define("restaurant-menu", restaurantMenu);